import { Repository } from "src/firebase/firestore/repository";
import { Address } from "src/entities/user-address.entity";

export class UserAddressRepository extends Repository<Address> {
  constructor(userId: string) {
    super("users", userId, "addresses");
  }
}

export function createUserAddressRepository(userId: string) {
  return new UserAddressRepository(userId);
}
